import Notification from "../singleton/notification";

export default {

    onCollectionMessage: Notification.onCollectionMessage.bind(Notification),

    onRecordMessage: Notification.onRecordMessage.bind(Notification),

    onDictionaryMessage: Notification.onDictionaryMessage.bind(Notification),

    onParamMessage: Notification.onParamMessage.bind(Notification),

    onAnyMessage: Notification.onAnyMessage.bind(Notification),

    offCollectionMessage: Notification.offCollectionMessage.bind(Notification),

}